import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {HeroSectionComponent} from '../shared/hero-section/hero-section.component';
import { RouterModule } from '@angular/router';
import { ImageWithTextComponent } from './image-with-text/image-with-text.component';
import {ManageComplianceComponent} from '../shared/manage-compliance/manage-compliance.component';
import {ExpansionPanelComponent} from '../shared/expansion-panel/expansion-panel.component';
import {MajorFrameworksComponent} from '../shared/Major-Frameworks/major-frameworks.component';
import {FeatureSectionComponent} from '../shared/feature-section/feature-section.component';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatDividerModule} from '@angular/material/divider';
import { AppSideAccordion } from './side-accordion/side-accordion.component';
 import {MatIconModule} from '@angular/material/icon';
import { ListWithImageComponent } from './list-with-image/list-with-image.component';
import { L10nTranslationModule } from 'angular-l10n';
import { l10nConfig } from 'src/app/l10n-config';
import { NguCarouselModule } from '@ngu/carousel';

 const SHARED_DECLARATIONS: Array<any> = [
  HeroSectionComponent,
  ImageWithTextComponent,
  ManageComplianceComponent,
  ExpansionPanelComponent,
  MajorFrameworksComponent,
  FeatureSectionComponent,
   AppSideAccordion,
   ListWithImageComponent

];

@NgModule({
  declarations: [SHARED_DECLARATIONS],
  imports: [
    CommonModule,
    RouterModule,
    MatExpansionModule,
    MatDividerModule,
    MatIconModule,
    L10nTranslationModule.forRoot(l10nConfig),
    NguCarouselModule,
  ],
  exports: [SHARED_DECLARATIONS]
})
export class SharedModule { }
